<template>
  <div class="DocumentsAISummaryMessageFromAI" data-locator="summary-item">
    <AppChatMessageSeparator :date="String(messageDate)" class="mb-6" />

    <AppChatMessage
      data-locator="summary-subject"
      class="mb-6"
      isFromUser
    >
      <template #message-author>
        <v-avatar class="profile-menu-item__initials text-caption"
                  size="32"
        >
          <span class="font-weight-bold">
            {{ profile.initials }}
          </span>
        </v-avatar>
      </template>
      <div>
        {{ $t('project.documents.ai-summary.DocumentsAISummaryRequestChatMessage.generateDocumentSummary') }}
        <DocumentSelectionListItem
          :document="documentToSummarize"
          class="document-to-summarize mt-2"
          data-locator="document"
        />
      </div>
    </AppChatMessage>

    <slot name="before-summary" />

    <AppChatMessage
      v-if="shouldDisplaySummaryMessage && !shouldDisplayErrorMessage && !$slots['before-summary']"
      class="mb-2"
      data-locator="successful-summary"
    >
      <template #message-author>
        <v-img
          src="@/assets/img/ai_assistant_ico.svg"
          :width="32"
          :height="32"
        />
      </template>
      <div class="d-flex align-center">
        <app-material-icon name="check" color="#068925" class="mr-2" />
        {{ $t('project.documents.ai-summary.DocumentsAISummaryRequestChatMessage.hereIsYourSummary') }}
      </div>
    </AppChatMessage>

    <AppChatMessage
      v-if="$slots['default']"
      :class="{ 'ml-9': shouldDisplaySummaryMessage && !shouldDisplayErrorMessage }"
      :shouldDisplayErrorMessage="shouldDisplayErrorMessage"
      :data-locator="shouldDisplayErrorMessage ? 'failed-summary' : 'summary-content'"
    >
      <template #message-author v-if="isSummaryRequestPending || shouldDisplayErrorMessage">
        <v-img
          src="@/assets/img/ai_assistant_ico.svg"
          :width="32"
          :height="32"
        />
      </template>

      <slot />
    </AppChatMessage>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { mapState } from 'vuex'

import AppChatMessage from '@/common/app-chat/AppChatMessage.vue'
import AppChatMessageSeparator from '@/common/app-chat/AppChatMessageSeparator.vue'
import DocumentSelectionListItem from '@/common/document-selection/DocumentSelectionListItem.vue'
import { DARK_BLUE_DARKEST } from '@/common/utils/colors'

export default defineComponent({
  name: 'DocumentsAISummaryMessageFromAI' ,
  components: {
    AppChatMessage,
    AppChatMessageSeparator,
    DocumentSelectionListItem,
  },
  props: {
    messageDate: {
      type: String,
      required: true,
    },
    isSummaryRequestPending: {
      type: Boolean,
      default: false,
    },
    shouldDisplaySummaryMessage: {
      type: Boolean,
      default: false,
    },
    shouldDisplayErrorMessage: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      DARK_BLUE_DARKEST,
    }
  },
  computed: {
    ...mapState('user', ['profile']),
    ...mapState('documentsAISummary', ['documentToSummarize']),
  },
})
</script>

<style lang="scss">
.DocumentsAISummaryMessageFromAI {
  .profile-menu-item {
    &__initials {
      color: white;
      background: v-bind(DARK_BLUE_DARKEST);
    }
  }
  .document-to-summarize {
    max-width: 247px;
    color: #103051 !important;
  }
}
</style>
